import React from 'react';
import { Message } from 'semantic-ui-react';
import './ErrorMessage.css';

const ErroMessage = ({ error }) => {
  return (
    <Message
      className="ErrorMessage"
      negative
      header="Sorry, er is iets foutgegaan bij het ophalen van de data."
      content={error}
    />
  );
};

export default ErroMessage;



// WEBPACK FOOTER //
// ./src/components/UtilityComponents/ErrorMessage/index.js